import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';

import { trans } from '../../../../common/utils';
import { DeleteFavoriteItemModal } from './delete-fav-tournament-modal';
import FilteredPrematchesList from '../../mobile/components/filtered-prematches/filtered-prematches-list';
import { LLInput, llNotifier, LLPreloader, WithDropdown } from '../../../../components';
import cx from 'classnames';
import MyFavoritesMatchesList from './my-favorites-match-list';
import MyFavoriteSportSelect from './sport-select';

const MyFavoriteTournament = ({ item, store, isFavorite, tournamentsSearchValue, setView, setTab, }) => {
    return (
        <p className="my-favorite__list-item">
            <span className="my-favorite__list-item-fav-icon-wrp">
                <i
                    className={`my-favorite__list-item-fav-icon doruk-star-${isFavorite ? 'fill' : 'line'}`}
                    onClick={() => {
                        isFavorite
                            ? store.modal.setModal({
                                  active: true,
                                  maskBackground: true,
                                  showHeader: true,
                                  title: trans('Favorite tournaments'),
                                  showCloseButton: true,
                                  currentKey: 'custom-content',
                                  customClasses: 'delete-favorite-modal',
                                  customContent: (
                                      <DeleteFavoriteItemModal
                                          deleteItem={(e) => {
                                              e.preventDefault();
                                              store.betting.favorites.setFavoriteTournament({
                                                  id: +item.id,
                                                  sportId: +item.sportId,
                                                  categoryId: +item.categoryId,
                                                  isFavorite: true,
                                              });
                                              store.modal.close();
                                          }}
                                          type="tournament"
                                      />
                                  ),
                              })
                            : store.betting.favorites.setFavoriteTournament({
                                  id: item.id,
                                  sportId: item.sportId,
                                  categoryId: item.categoryId,
                              });
                    }}
                ></i>
            </span>
            <span
                className={cx('my-favorite__list-item-content', isFavorite && 'clickable')}
                onClick={() => {
                    if (isFavorite) {
                        store.betting.favorites.initializeInstruction({
                            type: 'tournaments',
                        });
                        setTab('tournaments');
                        store.betting.favorites.setCurrentId(item.id, 'tournaments');
                        setView('matches');
                    }
                }}
            >
                <span className="my-favorite__list-item-sport-icon">
                    <i className={`sport_icon_font-${item.sportId}`}></i>
                </span>
                <span className="my-favorite__list-item-name">
                    <span>{item.sportName}</span>
                    <span> > </span>
                    <span>{item.categoryName}</span>
                    <span> > </span>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: tournamentsSearchValue ? item.name?.replace(new RegExp(tournamentsSearchValue, 'gi'), "<span class='my-favorite__list-item-name--highlited'>$&</span>") : item.name,
                        }}
                    />
                </span>
            </span>
        </p>
    );
};

const MyFavoriteTournaments = ({ store, view, setView, tab, setTab }) => {
    const favTournaments = store.betting.favorites.tournaments,
        error = store.betting.bettingErrors.favoriteTournaments,
        viewSize = store.site.status.viewSize,
        searchTournaments = store.betting.favorites.searchTournaments,
        tournamentsSearchValue = store.betting.favorites.tournamentsSearchValue;

    const
        [searchValSport, setSearchValSport] = useState(null),
        [searchVal, setSearchVal] = useState('');

    useEffect(() => {
        setView('default');
    }, [])

    const search = () => {
        if (searchVal?.length && searchVal?.length < 3) {
            llNotifier({
                message: 'Minimum 3 characters required',
                type: 'warning',
                options: {},
            });
            return null;
        }
        const params = { searchVal };
        if (searchValSport.id) {
            params.sportId = searchValSport.id;
        }
        store.betting.favorites.getSearchTournaments(params);
        store.betting.favorites.setCurrentId(null, 'tournaments');
        setView('default');
    };

    return (
        <div className="my-favorite__tournametns">
            <div className="my-favorite__column-top">
                <MyFavoriteSportSelect setSearchValSport={setSearchValSport} searchValSport={searchValSport} />
                <LLInput
                    customClasses="my-favorite__teams-input"
                    placeholder={trans('Search for tournaments')}
                    mode="text"
                    id="my-favorite-tournaments__search"
                    name="my-favorite-tournaments__search"
                    value={searchVal}
                    onEnterKey={search}
                    onValueChanged={(e) => setSearchVal(e.value)}
                    stylingMode="outlined"
                    adormentAfter={
                        <div className={`my-favorite__teams-input-icons${tournamentsSearchValue ? '--clear' : '--search'}`}>
                            <span className="my-favorite__teams-input-icon dx-icon-search icon" onClick={search} />
                            <span
                                className="my-favorite__teams-input-icon dx-icon-remove icon"
                                onClick={() => {
                                    setSearchVal('');
                                    store.betting.favorites.clearSearchTournaments();
                                }}
                            />
                        </div>
                    }
                ></LLInput>
            </div>
            <div className={cx('my-favorite__column-header', tab === 'tournaments' && view === 'matches' && 'my-favorite__column-header--active')}>
                <p className="my-favorite__column-header-text">
                    {viewSize === 'mobile' ? <i className="my-favorite__column-header-icon doruk-trophy-fill"></i> : null}
                    <span>{trans('Tournaments')}</span>
                    {viewSize !== 'mobile' ? <span>({favTournaments?.length ?? 0}/50)</span> : null}
                </p>
                <p
                    className="my-favorite__column-header-show-btn"
                    onClick={() => {
                        if (view === 'default') {
                            store.betting.favorites.initializeInstruction({
                                type: 'tournaments',
                            });
                            setTab('tournaments');
                            setView('matches');
                        }
                        if (view === 'matches') {
                            store.betting.favorites.setCurrentId(null, 'tournaments');
                            setView('default');
                        }
                    }}
                >
                    {trans(view === 'default' ? 'Show matches' : tab === 'tournaments' ? 'Clear matches' : '')}
                </p>
            </div>
            {view !== 'matches' ? (
                <div className="my-favorite__column-content-wrp">
                    {store.betting.favorites.tournamentsLoading && (
                        <div className="my-favorite__column-content-laoding">
                            <LLPreloader height={50} width={50} />
                        </div>
                    )}
                    <div className="my-favorite__column-content">
                        {tournamentsSearchValue ? (
                            searchTournaments.length ? (
                                searchTournaments.map((tournament) => (
                                    <MyFavoriteTournament
                                        item={tournament}
                                        isFavorite={store.betting.favorites.isTournamentFavorite({ id: tournament.id })}
                                        store={store}
                                        setView={setView}
                                        setTab={setTab}
                                        tournamentsSearchValue={tournamentsSearchValue}
                                        key={tournament.id}
                                    />
                                ))
                            ) : (
                                <p className="my-favorite__no-content-text">{trans('NO_SEARCH_TOURNAMENTS_TEXT')}</p>
                            )
                        ) : !error && favTournaments?.length ? (
                            favTournaments.map((tournament) => (
                                <MyFavoriteTournament
                                    item={tournament}
                                    isFavorite={store.betting.favorites.isTournamentFavorite({ id: tournament.id })}
                                    store={store}
                                    setView={setView}
                                    setTab={setTab}
                                    tournamentsSearchValue={tournamentsSearchValue}
                                    key={tournament.id}
                                />
                            ))
                        ) : (
                            <div className="my-favorite__no-content">
                                <i className="my-favorite__no-content-icon doruk-trophy-fill"></i>
                                <p className="my-favorite__no-content-text">{trans(error || 'NO_FAV_TOURNAMENTS_TEXT')}</p>
                            </div>
                        )}
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default inject('store')(observer(MyFavoriteTournaments));
